module.exports = __webpack_public_path__ + "er.svg?6b8e7d6401e1e49712f108afaad508c3";